import { createIconComponent } from '../../factory/create-icon-component';
export const LampIcon = createIconComponent(
  'LampIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 18C9 18 10 18.5 12 18.5C14 18.5 15 18 15 18"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 2C7.58172 2 4 5.58172 4 10C4 12.9482 6.2263 15.3013 7.70778 16.5408C8.47633 17.1838 9 18.1102 9 19.1123C9 20.7071 10.2929 22 11.8877 22H12.1268C13.7136 22 15 20.7136 15 19.1268C15 18.1175 15.5342 17.1861 16.3119 16.5427C17.7933 15.317 20 12.9895 20 10C20 5.58172 16.4183 2 12 2Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 18L12 14"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
